export const commonRules = {
  data () {
    return {
      commonRules: {
        requiredRule: [ v => !!v || '必填' ]
      }
    }
  }
}

export const formatRules = {
  data () {
    return {
      formatRules: {
        phoneRules: [ v => (this.isBlank(v) || (/[0][9]\d{7}\w+/g.test(String(v)) && String(v).length === 10)) || '不符合手機號碼格式' ]
      }
    }
  },
  methods: {
    isBlank: function (v) {
      return v == null || v === ''
    }
  }
}
